// noinspection DuplicatedCode

import React from 'react';
import PropTypes from 'prop-types';
import MenuItem from '@material-ui/core/MenuItem';
import ContextMenu from '@/modules/common/components/ContextMenu';

const Component = (props) => {
    return (
        <ContextMenu position={props.position} onClose={props.onClose}>
            <MenuItem onClick={props.onClickEdit}>Изменить</MenuItem>
            <MenuItem onClick={props.onClickChangePassword}>Изменить пароль</MenuItem>
            <MenuItem onClick={props.onClickDelete}>Удалить</MenuItem>
        </ContextMenu>
    );
};

Component.propTypes = {
    position: PropTypes.object.isRequired,
    onClickEdit: PropTypes.func.isRequired,
    onClickChangePassword: PropTypes.func.isRequired,
    onClickDelete: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
};

export default Component;
